import { render, staticRenderFns } from "./aitest.vue?vue&type=template&id=010bfdb2&scoped=true&"
import script from "./aitest.vue?vue&type=script&lang=js&"
export * from "./aitest.vue?vue&type=script&lang=js&"
import style0 from "./aitest.vue?vue&type=style&index=0&id=010bfdb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010bfdb2",
  null
  
)

export default component.exports